// // We read this from env variable to support templating during the build process
import { getConfig } from '@config/index'

import {
  PUBLIC_STATIC_ASSET_PREFIX,
  CDN_URL,
  IS_PRODUCTION,
  PUBLIC_FONTS_VERSION,
  PUBLIC_IMAGES_VERSION,
  PUBLIC_VIDEOS_VERSION,
  PUBLIC_CSS_VERSION,
  SHARED_FONTS_VERSION,
} from '@constants/globals'

const createPath = (...parts: string[]) =>
  parts
    .map((p, i) => (i === 0 ? p.replace(/\/+$/, '') : p.replaceAll(/^\/+|\/+$/g, '')))
    .filter(Boolean)
    .join('/')

const stripLastExt = (key: string): string =>
  key.replace(/\/+$/, '').replace(/([^/]+)\.[A-Za-z0-9]+$/, (_m, name: string) => name)

const encodeSegments = (key: string): string =>
  key
    .split('/')
    .filter(Boolean)
    .map(seg => encodeURIComponent(seg))
    .join('/')

const withPublicAssetUrl = (asset: string): string => {
  return IS_PRODUCTION ? `${CDN_URL}${PUBLIC_STATIC_ASSET_PREFIX}/${asset}` : `/static/${asset}`
}

export const withMediaResourceUrl = (asset: string): string => {
  const canonical = stripLastExt(asset.trim())
  const assetName = encodeSegments(canonical)
  const basePath = getConfig().paths.basePath
  return IS_PRODUCTION ? `${basePath}/media-resources/${assetName}` : `/static/${asset}`
}

export const withPublicFontUrl = (file: string): string =>
  withPublicAssetUrl(createPath('fonts', PUBLIC_FONTS_VERSION, file))

export const withPublicImageUrl = (file: string): string =>
  withPublicAssetUrl(createPath('images', PUBLIC_IMAGES_VERSION, file))

export const withPublicVideoUrl = (file: string): string =>
  withPublicAssetUrl(createPath('videos', PUBLIC_VIDEOS_VERSION, file))

export const withPublicCssUrl = (file: string): string =>
  withPublicAssetUrl(createPath('css', PUBLIC_CSS_VERSION, file))

// TODO: Make font, image, video specific functions out of these below functions and stop exporting these
export const withSharedAssetUrl = (asset: string): string => {
  return `${CDN_URL}/s/${asset}`
}

export const withSharedFontUrl = (file: string): string =>
  withSharedAssetUrl(createPath('fonts', SHARED_FONTS_VERSION, file))
